<template>
    <v-container class="pa-0">
        <v-row no-gutters>
            <v-col :cols="12">
                <FormHeader title="SCENARIO"/>
            </v-col>
        </v-row>
        <v-container class="white ">
            <v-row no-gutters>
                <v-col :cols="12">
                    <draggable v-model="list" group="actions" :move="checkMove" @start="drag=true" @end="drag=false" @update="onDraggable" handle=".draggable">
                        <v-sheet :class="{ draggable: element.type !== 'wildcard'}" class="mt-2 pa-2 d-flex" outlined rounded v-for="(element, index) in scenarioList"
                                 :key="index" style="min-height: 100px">
                            <v-icon class="mr-2">{{ element.type !== 'wildcard' ? 'mdi-format-list-bulleted' : 'mdi-card-bulleted-off-outline' }}</v-icon>
                            <v-row no-gutters align="center">
                                <v-col :cols="2" class="pr-2 align-center">
                                    <v-row no-gutters align="center">
                                        <v-col :cols="12">{{element.type}} action |</v-col>
                                    </v-row>
                                </v-col>
<!--                                click action form-->
                                <v-col :cols="10" class="align-center" v-if="element.type === 'click'">
                                    <v-row no-gutters align="center">
                                        <v-col cols="5" lg="4" class="mt-4">
                                            <v-row no-gutters align="baseline">
                                                <v-col cols="4">
                                                    <v-subheader>XPath:</v-subheader>
                                                </v-col>
                                                <v-col cols="8">
                                                    <v-text-field
                                                        v-bind:id="index + '-xpath'"
                                                        v-model="element.xpath"
                                                        placeholder="//button[@class='accept']"
                                                        outlined
                                                        single-line
                                                        dense
                                                        required
                                                        :hint="xPathRule && element.xpath ? xPathQuality(element.xpath) : null"
                                                        persistent-hint
                                                        :rules="[xPathRule]"
                                                    ></v-text-field>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                        <v-col :cols="4" class="mt-4">
                                            <v-row no-gutters align="baseline">
                                                <v-col cols="4">
                                                    <v-subheader>Name:</v-subheader>
                                                </v-col>
                                                <v-col cols="8">
                                                    <v-autocomplete
                                                          v-model="element.name"
                                                          :items="buttonNameItems"
                                                          name="button_name"
                                                          placeholder="Accept button"
                                                          dense
                                                          outlined
                                                          required
                                                          :rules="[v => !!v || 'This field is required']"
                                                      ></v-autocomplete>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                        <v-col cols="3" lg="4">
                                            <v-row no-gutters align="center">
                                                <v-col cols="7" lg="5">
                                                    <v-subheader>Click All</v-subheader>
                                                </v-col>
                                                <v-col cols="5" lg="7">
                                                    <v-switch
                                                            v-model="element.click_all"
                                                            name="clickAll"
                                                            inset
                                                            solo
                                                            dense
                                                    ></v-switch>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                    </v-row>
                                </v-col>

<!--                                delay action form-->
                                <v-col :cols="8" class="align-center" v-if="element.type === 'delay'">
                                    <v-row no-gutters align="center">
                                        <v-col cols="6" lg="5" class="mt-4">
                                            <v-row no-gutters align="baseline">
                                                <v-col cols="4">
                                                    <v-subheader>Duration:</v-subheader>
                                                </v-col>
                                                <v-col cols="8">
                                                    <v-text-field
                                                            v-model="element.duration"
                                                            placeholder="2.5s"
                                                            outlined
                                                            dense
                                                            single-line
                                                            type="number"
                                                            required
                                                            :rules="[v => !!(v && v > 0) || 'Value must be more than 0']"
                                                            @change="handleDelay(element)"
                                                    ></v-text-field>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                    </v-row>
                                </v-col>
<!--                                insert action form-->
                                <v-col :cols="10" class="align-center" v-if="element.type === 'insert'">
                                    <v-row no-gutters align="center">
                                        <v-col cols="5" lg="4" class="mt-4">
                                            <v-row no-gutters align="baseline">
                                                <v-col cols="4">
                                                    <v-subheader>XPath:</v-subheader>
                                                </v-col>
                                                <v-col cols="8">
                                                    <v-text-field
                                                            v-bind:id="index + '-xpath'"
                                                            v-model="element.xpath"
                                                            placeholder="//button[@class='accept']"
                                                            outlined
                                                            single-line
                                                            dense
                                                            required
                                                            :hint="xPathRule && element.xpath ? xPathQuality(element.xpath) : null"
                                                            persistent-hint
                                                            :rules="[xPathRule]"
                                                    ></v-text-field>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                        <v-col :cols="4" class="mt-4">
                                            <v-row no-gutters align="baseline">
                                                <v-col cols="4">
                                                    <v-subheader>Text:</v-subheader>
                                                </v-col>
                                                <v-col cols="8">
                                                    <v-text-field
                                                            v-model="element.text"
                                                            placeholder="Text"
                                                            outlined
                                                            dense
                                                            single-line
                                                            :rules="[v => !!v || 'This field is required']"
                                                            required
                                                    ></v-text-field>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>

                            <v-icon @click="removeAt(index)">
                                mdi-close
                            </v-icon>
                        </v-sheet>
                    </draggable>
                </v-col>
            </v-row>
            <v-row>
                <v-col :cols="2" >
                    <v-menu
                            transition="slide-y-transition"
                            bottom
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                    class="ma-3"
                                    v-bind="attrs"
                                    v-on="on"
                                    depressed
                            >
                                + ADD ACTION
                            </v-btn>
                        </template>
                        <v-list>
                            <v-list-item-group>
                                <v-list-item
                                        v-for="(item, i) in items"
                                        :key="i"
                                        @click="add(item.type)"
                                >
                                    <v-list-item-title>
                                        <v-icon>mdi-plus-thick</v-icon>
                                        {{ item.type }}
                                    </v-list-item-title>
                                </v-list-item>
                            </v-list-item-group>
                        </v-list>
                    </v-menu>
                </v-col>
                <v-col :cols="2" >
                    <v-menu
                            transition="slide-y-transition"
                            bottom
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                    class="ma-3"
                                    v-bind="attrs"
                                    v-on="on"
                                    depressed
                            >
                                + SCENARIO TEMPLATE
                            </v-btn>
                        </template>
                        <v-list>
                            <v-list-item-group>
                                <v-list-item
                                        v-for="(item, i) in templates"
                                        :key="i"
                                        @click="setTemplate(item.type)"
                                >
                                    <v-list-item-title>
                                        <v-icon>mdi-plus-thick</v-icon>
                                        {{ item.type }}
                                    </v-list-item-title>
                                </v-list-item>
                            </v-list-item-group>
                        </v-list>
                    </v-menu>
                </v-col>
            </v-row>
        </v-container>
    </v-container>
</template>

<script>
    import draggable from "vuedraggable";
    import FormHeader from "../FormHeader";

    export default {
        name: "ScenarioForm",
        order: 5,
        components: {
            draggable,
            FormHeader,
        },
        data() {
            return {
                list: [],
                buttonNameItems: (this.consentType.name === 'BefConsent' || this.consentType.name === 'LoginBeforeCons') ? ['Generic'] : ['Choices Saved', 'Generic'],
                dragging: true,
                items: [
                    {type: 'wildcard'},
                    {type: 'click', xpath: "", name: "", click_all: false},
                    {type: 'delay', duration: 1},
                    {type: 'refresh'},
                    {type: 'insert', xpath: "", text: ""},
                    {type: 'scrolling'},
                ],
                templates: [
                    {
                        type: 'Before Consent',
                        actions: [
                            {type: 'delay', duration: 30},
                            {type: 'refresh'},
                            {type: 'delay', duration: 30}
                            ]
                    },
                    {
                        type: 'Accept All',
                        actions: [
                            {type: 'delay', duration: 30},
                            {type: 'click', xpath: "", name: 'Choices Saved', click_all: false},
                            {type: 'refresh'},
                            {type: 'delay', duration: 30}
                            ]
                    },
                    {
                        type: 'Reject All',
                        actions: [
                            {type: 'delay', duration: 30},
                            {type: 'click', xpath: "", name: 'Generic', click_all: false},
                            {type: 'refresh'},
                            {type: 'delay', duration: 30},
                            {type: 'click', xpath: "", name: 'Choices Saved', click_all: false},
                            {type: 'delay', duration: 30}
                            ]
                    },
                    {
                          type: 'Accept All + Wildcard',
                          actions: [
                              {type: 'wildcard'},
                              {type: 'delay', duration: 30},
                              {type: 'click', xpath: "", name: 'Choices Saved', click_all: false},
                              {type: 'refresh'},
                              {type: 'delay', duration: 30}
                          ]
                    },
                    {
                          type: 'Before Consent + Wildcard',
                          actions: [
                              {type: 'wildcard'},
                              {type: 'delay', duration: 30},
                              {type: 'refresh'},
                              {type: 'delay', duration: 30}
                          ]
                    },
                    {
                          type: 'Reject All + Wildcard',
                          actions: [
                              {type: 'wildcard'},
                              {type: 'delay', duration: 30},
                              {type: 'click', xpath: "", name: 'Generic', click_all: false},
                              {type: 'refresh'},
                              {type: 'delay', duration: 30},
                              {type: 'click', xpath: "", name: 'Choices Saved', click_all: false},
                              {type: 'delay', duration: 30}
                          ]
                    },
                ],
                xPathRule: v =>{
                    if (!(v && Object.keys(v).length !== 0)) {
                        return 'This field is required';
                    } else if(!(v && this.getElementByXpath(v) && v.includes('/'))){
                        return 'This value is not a valid XPath expression';
                    } return true;
                },
            };
        },
        methods: {
            removeAt(idx) {
                this.list.splice(idx, 1);
                this.$emit('remove-scenario', this.list);
            },
            add(type) {
                this.$emit('add-scenario', this.list );
                let actionType = {};
                this.items.forEach(function(item) {
                    if(type === item.type){
                        actionType = {...item};
                    }
                });
                if(actionType?.type === 'wildcard'){
                    this.list.unshift(actionType);
                } else {
                    this.list.push(actionType);
                }
            },
            setTemplate(type){
                let actionType = [];
                this.templates.forEach(function(template) {
                    if(type === template.type){
                        actionType = [...template.actions];
                    }
                });
                this.list = actionType;
                this.$emit('add-scenario', this.list);
            },
            onDraggable(){
                this.$emit('updated', this.list);
            },
            checkMove(e) {
                return e.draggedContext.futureIndex !== 0;
            },
            handleDelay(element){
                this.list.forEach((item, i)=>{
                    if( item.type === element.type){
                        this.list[i].duration = +this.list[i].duration;
                    }
                })
            },
            getElementByXpath(path) {
                try{
                    document.evaluate(path, document, null, XPathResult.FIRST_ORDERED_NODE_TYPE, null).singleNodeValue;
                    return true
                } catch (e) {
                    //eslint-disable-next-line
                    console.log(e);
                    return false
                }
            },
            regexpMatchCount: (regexp, v) => {
              let matchCount = 0;
              let result
              do {
                result = regexp.exec(v);
                if (result !== null) {
                  matchCount++
                }
              } while (result !== null);

              return matchCount;
            },
            xPathQuality(v) {
              const regexUsingIndexing = /\[(\d|[^[\]]*last.*\(.*\)|[^[\]]*position.*\(.*\).+?)?\]/gm;
              const regexTooManyParts = /(\/\/?[^/]+)/gm;
              const regexUsingBlank = /\.?\/\/?\*/gm;

              let rate = this.regexpMatchCount(regexUsingIndexing, v) * 5
                  + (this.regexpMatchCount(regexTooManyParts, v) > 4 ? this.regexpMatchCount(regexTooManyParts, v) * 2 : 0)
                  + this.regexpMatchCount(regexUsingBlank, v);

              if(rate === 0){
                  return 'Good XPath expression!';
              } else if(rate > 0 && rate <=10){
                  return 'Your XPath expression is OK!';
              } else if(rate > 10 && rate <=20){
                  return 'Bad XPath expression!';
              } else if(rate > 20){
                  return 'Very Bad XPath expression!';
              }
            }
        },
        props: {
            scenarioList:{
                type: Array
            },
            consentType:{
                type: Object
            }
        },
        created() {
            if(this.$route.params.scanId){
                this.list = this.scenarioList;
            }
        },
        watch: {
          consentType: function(newVal) {
            if(newVal.name === 'BefConsent' || newVal.name === 'LoginBeforeCons'){
              this.list.forEach((action, index) => {
                if(action.type === 'click' && action.name === 'Choices Saved'){
                  this.list[index].name = '';
                }
              })
              this.buttonNameItems = ['Generic']
            } else {
              this.buttonNameItems = ['Choices Saved', 'Generic']
            }
          }
        }
    };
</script>
